import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
import type { Permission } from '@/apis/interface/permissionManage'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 获取角色列表
export const getRoleListApi = () => {
  return request.post('/admin/role/list', null, jsonHeaderConfig)
}

// 获取所有角色列表（包含超级管理员）
export const getAllRoleListApi = () => {
  return request.post('/admin/role/list/all', null, jsonHeaderConfig)
}

// 获取角色的权限菜单
export const getRoleMenuApi = (roleId: string, systemCode: string) => {
  return request.post(
    `/admin/role/menuList?roleId=${roleId}&systemCode=${systemCode}`,
    null,
    jsonHeaderConfig
  )
}

// 设置菜单权限
export const setRoleMenuPermissionApi = (params: Permission.ReqMenuPermissionParams) => {
  return request.post('/admin/role/permissions', params, jsonHeaderConfig)
}

// 设置角色所有子系统的菜单
export const setRoleSystemPermissionApi = (params: any) => {
  return request.post('/admin/role/system/permissions', params, jsonHeaderConfig)
}

// 移除角色下用户
export const removeRoleUserApi = (userId: string, roleId: string) => {
  return request.post(
    `/admin/user/removeRoleUser?userId=${userId}&roleId=${roleId}`,
    null,
    jsonHeaderConfig
  )
}

// 获取配置数据权限列表
export const getPermissionListApi = () => {
  return request.get('/admin/resource/listDataScope', null, jsonHeaderConfig)
}

// 设置菜单权限
export const setDataScopeApi = (params: Permission.ReqScopeDataParams) => {
  return request.post('/admin/role/dataScope', params, jsonHeaderConfig)
}

// 设置脱敏字段
export const setDesensitizeApi = (data: any[]) => {
  return request.post('/admin/application/system/configDesensitize', data, jsonHeaderConfig)
}

// 获取脱敏字段
export const getDesensitizeApi = (roleId: string): Promise<any> => {
  return request.post(
    `/admin/application/system/field/list?roleId=${roleId}`,
    null,
    jsonHeaderConfig
  )
}

// 获取角色详情
export const getRoleDetailApi = (id: string): Promise<Permission.ReqRoleDetailReturn> => {
  return request.post(`/admin/role/details?id=${id}`, null, jsonHeaderConfig)
}

// 设置角色详情
export const setRoleDetailApi = (
  roleId: string,
  dataScopeList: string[],
  departmentIdList: string[]
) => {
  return request.post(
    '/admin/role/all/dataScope',
    { roleId, dataScopeList, departmentIdList },
    jsonHeaderConfig
  )
}

// 获取子应用列表
export const getSubSystemApi = (roleId: string) => {
  return request.get(`/admin/application/subSystems?roleId=${roleId}`, null, jsonHeaderConfig)
}

// 获取移交列表
export const getTransferUserApi = (roleId: string) => {
  return request.post(
    `/admin/application/system/find/transferRole?roleId=${roleId}`,
    null,
    jsonHeaderConfig
  )
}

export const getSystemMenuList = (id: string) => {
  return request.post(`/admin/role/system/menuList?roleId=${id}`, null, jsonHeaderConfig)
}

export const setTransferRole = (params: any) => {
  return request.post('/admin/application/system/config/transferRole', params, jsonHeaderConfig)
}

// 查询角色下的字段权限
export const getRoleFieldList = (params: any) => {
  return request.post(
    `/admin/role/fieldList?roleId=${params.roleId}&systemCode=${params.systemCode}`,
    params,
    jsonHeaderConfig
  )
}

// 查询所有角色下的字段权限
export const getAllRoleFieldList = (params: any) => {
  return request.post(
    `/admin/role/currentFieldList?appCode=${params.appCode}`,
    params,
    jsonHeaderConfig
  )
}

// 配置角色字段权限
export const setRoleFieldList = (params: any) => {
  return request.post('/admin/role/config/fields', params, jsonHeaderConfig)
}

// 查询角色下所有子系统的协助人范围配置  roleId
export const getAssistRole = ({ roleId }: any) => {
  return request.post(
    `/admin/application/system/find/assistRole?roleId=${roleId}`,
    null,
    jsonHeaderConfig
  )
}

// 配置角色下所有子系统的协助人范围配置
export const setAssistRole = (params: any) => {
  return request.post('/admin/application/system/config/assistRole', params, jsonHeaderConfig)
}
